import { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addNewTab, removeTab } from "../context/dashboardSlice";
import { useState } from "react";
import HttpService from "../services/http.service";
import { setScreenpopURL } from "../context/callSlice";
import { removeScreenpopFromStorage } from "../services/util";
import LocalStorageService from "../services/localstorage.service";

let url = null


export function ScreenPop(props) {
    const [windows, setWindows] = useState([]);
    const [nextWindowId, setNextWindowId] = useState(1);
    const dispatch = useDispatch();
    const callData = useSelector((state) => state.call.callDetails) || {}
    const isCallEnded = useSelector((state) => state.call.isCallEnded)
    const DONT_CLOSE_SPOP = useSelector((state) => state.toolbar.params.DONT_CLOSE_SPOP);
    const loginData = useSelector((state) => state.toolbar.loginDetails)

    const AGENT_ID_PH = useSelector((state) => state.toolbar.params.AGENT_ID_PH)
    const AGENT_KEY_PH = useSelector((state) => state.toolbar.params.AGENT_KEY_PH)
    const CUST_PH = useSelector((state) => state.toolbar.params.CUST_PH)
    const AGENT_PHONE_PH = useSelector((state) => state.toolbar.params.AGENT_PHONE_PH)
    const SEND_CUST_PARAMS = useSelector((state) => state.toolbar.params.SEND_CUST_PARAMS)
    const SPOP_CALLERID_ONLY = useSelector((state) => state.toolbar.params.SPOP_CALLERID_ONLY)
    const lastEventTimeRef = useRef(0);

    function handleCallScreenPop() {
        if (callData.screenPop && callData.screenPop !== null && callData.screenPop !== "") {

            let popurl = callData.screenPop + callData.callerId
                + "&ucid=" + callData.ucid
                + "&did=" + callData.did
                + "&callerID=" + callData.callerId
                + "&skillName=" + (callData?.skillName?.includes('#') ? callData?.skillName?.split('#')[0] : callData?.skillName)
                + "&agentUniqueID=" + callData.agentUniqueID
                + "&dataID=" + callData.dataId
                + "&campaignID=" + callData.campaignId
                + "&campaignName=" + callData.campaignName
                + "&monitorUcid=" + callData.monitorUcid
                + "&agentPhoneNumber=" + loginData.phoneNumber
                + "&phoneName=" + callData.phoneName
                + "&type=" + (callData.callType === 'IncomingCall' ? "Inbound" : "Manual")
                + "&apiKey=" + loginData.agentInfo.user.apiKey
                + "&event=" + callData.type
                + "&screenpopupType=ClientSide"

            if (callData.uui && callData.uui.match(/\S/g)) {
                popurl = popurl + "&uui=" + callData.uui;
            }
            if (callData.extraData && callData.extraData.match(/\S/g)) {
                popurl = popurl + callData.extraData;
            }
            if (popurl) {
                if (SEND_CUST_PARAMS === 'true') {
                    if (AGENT_ID_PH) {
                        popurl = popurl + '&' + AGENT_ID_PH + '=' + loginData.agentInfo.agentId
                    }
                    if (AGENT_KEY_PH) {
                        popurl = popurl + '&' + AGENT_KEY_PH + '=' + loginData.agentKey
                    }
                    if (CUST_PH) {
                        popurl = popurl + '&' + CUST_PH + '=' + loginData.customer
                    }
                    if (AGENT_PHONE_PH) {
                        popurl = popurl + '&' + AGENT_PHONE_PH + '=' + loginData.phoneNumber
                    }
                } else {
                    popurl = popurl + "&agentID=" + loginData.agentInfo.agentId + "&customer=" + loginData.customer
                }
            }
            if (SPOP_CALLERID_ONLY === 'true') {
                popurl = callData.screenPop + callData.callerId
            }
            // console.log("screenPopUp url=", popurl)
            if (popurl) {
                dispatch(setScreenpopURL(popurl)); // Dispatch the calculated url to Redux
            }
            console.log("screen pop URL constructed");
            return popurl
        }
    }

    const handleScreenpop = async () => {
        if (!isCallEnded && (callData.screenPopOn === "BOTH" || callData.screenPopOn === "CLIENT" || callData.screenPopOn === "PLUGIN" || callData.screenPopOn === "CLIENTBUSY")) {
            const IdeskScreenPopUrl = HttpService.getURL('idesk_screenpop_url');
            const contactManagerIntegrationId = HttpService.getURL('contact_manager_integration_id');
            const contactManagerScreenpopUrl = HttpService.getURL('contact_manager_screenpop_url');
            if (callData.screenPop && callData.screenPop !== null && callData.screenPop !== ""
                && callData.screenPopMode !== null && callData.screenPopMode !== undefined && callData.screenPopMode !== "") {
                if (!(callData.screenPopOn === "PLUGIN" && callData.screenPop !== IdeskScreenPopUrl) &&
                    callData.type === "newCall" && callData.screenPopOn !== "CLIENTBUSY") {
                    url = handleCallScreenPop(callData);
                    if (callData.screenPopMode === "1") {
                        dispatch(addNewTab('Pop CRM'));
                        console.log("newCall: Pop up CRM open mode is 1");
                        LocalStorageService.setItem("DashboardActiveTab", 'Pop CRM')
                    }
                    if (callData.screenPopMode === "2") {
                        openWindow(url, "ozo_screen", "status=1,width=1024,height=600")
                        console.log("newCall: screen pop opened in a new window mode is 2");
                    }
                    if (callData.screenPopMode === "3") {
                        openWindow(url, '_blank', '');
                        console.log("newCall: screen pop opened in a new Tab mode is 3");
                    }
                }
                else if (callData.screenPopOn === "CLIENTBUSY" && callData.type === "busyAgent") {
                    url = handleCallScreenPop(callData);
                    if (callData.screenPopMode === "1") {
                        dispatch(addNewTab('Pop CRM'));
                        LocalStorageService.setItem("DashboardActiveTab", 'Pop CRM')
                        console.log("busyAgent: Pop up CRM open mode is 1");
                    }
                    if (callData.screenPopMode === "2") {
                        openWindow(url, "ozo_screen", "status=1,width=1024,height=600");
                        console.log("busyAgent: screen pop opened in a new window mode is 2");
                    }
                    if (callData.screenPopMode === "3") {
                        openWindow(url, '_blank', '');
                        console.log("busyAgent: screen pop opened in a new Tab mode is 3");
                    }
                }
            }
            else if (loginData.agentInfo?.user?.screenPopMode !== null && loginData.agentInfo?.user?.screenPopMode !== "") {
                if (!(callData.screenPopOn === "PLUGIN" && callData.screenPop !== IdeskScreenPopUrl)) {
                    url = handleCallScreenPop(callData);
                    if (url) {
                        if (loginData.agentInfo?.user?.screenPopMode === 1) {
                            dispatch(addNewTab('Pop CRM'))
                            LocalStorageService.setItem("DashboardActiveTab", 'Pop CRM');
                            console.log("idesk: Pop up CRM open mode is 1");
                        }
                        if (loginData.agentInfo?.user?.screenPopMode === 2) {
                            openWindow(url, "ozo_screen", "status=1,width=1024,height=600");
                            console.log("idesk: screen pop opened in a new window mode is 2");
                        }
                        if (loginData.agentInfo?.user?.screenPopMode === 3) {
                            openWindow(url, '_blank', '');
                            console.log("idesk: screen pop opened in a new Tab mode is 3");
                        }
                    }
                }
                else if (!(callData.screenPopOn === "PLUGIN" && contactManagerIntegrationId && callData.screenPop !== contactManagerScreenpopUrl)) {
                    url = handleCallScreenPop(callData);
                    if (url) {
                        if (loginData.agentInfo?.user?.screenPopMode === 1) {
                            dispatch(addNewTab('Pop CRM'))
                            LocalStorageService.setItem("DashboardActiveTab", 'Pop CRM');
                            console.log("contactManager: Pop up CRM open mode is 1");
                        }
                        if (loginData.agentInfo?.user?.screenPopMode === 2) {
                            openWindow(url, "ozo_screen", "status=1,width=1024,height=600");
                            console.log("contactManager: screen pop opened in a new window mode is 2");
                        }
                        if (loginData.agentInfo?.user?.screenPopMode === 3) {
                            openWindow(url, '_blank', '');
                            console.log("contactManager: screen pop opened in a new Tab mode is 3");
                        }
                    }
                }
            }
        }
    }

    useEffect(() => {
        const storedWindows = JSON.parse(localStorage.getItem('windows')) || [];
        setWindows(storedWindows);
    }, []);

    useEffect(() => {
        localStorage.setItem('windows', JSON.stringify(windows));
    }, [windows]);


    useEffect(() => {
        if (callData) {
            const currentTime = new Date().getTime();
            const timeSinceLastEvent = currentTime - lastEventTimeRef.current;
            // Ignore events that happen within 100ms of each other
            if (timeSinceLastEvent > 100) {
                lastEventTimeRef.current = currentTime;
                handlePopUp();
            }
        }
    }, [callData])

    const handlePopUp = async () => {
        await handleScreenpop();
    }
    useEffect(() => {
        if (DONT_CLOSE_SPOP === 'false' && isCallEnded) {
            closeWindow(callData.ucid)
        }
    }, []);

    const openWindow = (url, type, style) => {
        const isAlreadyExists = windows.find((win) => win.id === callData.ucid);
        if (!isAlreadyExists) {
            if (type === '_blank') {
                window.open(url, `window${callData.ucid}`);
            }
            else {
                window.open(url, `window${callData.ucid}`, type, style);
            }
            setWindows([...windows, { id: callData.ucid }]);
            setNextWindowId(callData.ucid);
        }
    };

    const closeWindow = (windowId) => {
        const windowToClose = windows.find((win) => win.id === windowId);
        if (windowToClose) {
            const windowName = `window${windowToClose.id}`;
            const windowToCloseRef = window.open('', windowName);
            if (windowToCloseRef) {
                windowToCloseRef.close();
            }
            const updatedWindows = windows.filter((win) => win.id !== windowId);
            setWindows(updatedWindows);
        }
        else {
            if (callData && callData.screenPopMode === "1" && DONT_CLOSE_SPOP === 'false') {
                dispatch(removeTab('Pop CRM'));
                removeScreenpopFromStorage('Pop CRM');
                dispatch(setScreenpopURL(null));
            }
            dispatch(removeTab('Script'));
        }
    };
}


export function ScreenPopTab() {
    const activeTab = useSelector((state) => state.dashboard.activeTab);
    const urlScreenpop = useSelector((state) => state.call.screenPopURL);
    const RETRY_KAP_SCREENPOP = useSelector((state) => state.toolbar.params.RETRY_KAP_SCREENPOP)
    const [retried, setRetried] = useState(false);
    const iframeRef = useRef(null);

    useEffect(() => {
        if (RETRY_KAP_SCREENPOP === 'true') {
            let responseTimer;
            let responseReceived = false;

            const handleMessage = (event) => {
                if (event.data && event.data.name === "KAPTURE_PAGE_LOADED") {
                    if (event.data.data && event.data.data.pageLoaded === true) {
                        responseReceived = true;
                        console.log("Kapture-OZ event received, screen pop loaded successfully", { retried, responseTimer, responseReceived, data: event.data });
                        clearTimeout(responseTimer);
                    }
                }
            };

            console.log("Kapture-OZ added event listener")
            window.addEventListener('message', handleMessage);

            const handleTimeout = () => {
                console.log("Kapture-OZ Handle timeout triggered", { retried, responseTimer, responseReceived })
                if (!responseReceived) {
                    if (!retried) {
                        console.log("Kapture-OZ First attempt timed out, retrying once more")
                        setRetried(true);
                        if (iframeRef.current) {
                            iframeRef.current.src = urlScreenpop;
                        }
                        responseTimer = setTimeout(() => {
                            console.log("Kapture-OZ responseTimer timeout", { responseReceived })
                            if (!responseReceived) {
                                console.log("Kapture-OZ Failed to load screen pop after retry");
                            }
                        }, 5000);
                    } else {
                        console.log("Kapture-OZ Failed to load screen pop, already retried");
                    }
                }
            };

            responseTimer = setTimeout(handleTimeout, 5000);

            return () => {
                console.log("Kapture-OZ remove message listener")
                window.removeEventListener('message', handleMessage);
                clearTimeout(responseTimer);
            };
        }
    }, [urlScreenpop, retried]);

    return (
        <iframe
            ref={iframeRef}
            src={urlScreenpop}
            sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-modals allow-downloads allow-popups-to-escape-sandbox"
            allow="geolocation; microphone; camera;display-capture"
            style={{
                width: '100%',
                height: '100%',
                display: activeTab === "Pop CRM" ? 'table-row' : 'none',
                border: '0'
            }}
            name="OzonetelPOPCRM"
            id="OzonetelPOPCRM"
            title="OzonetelPOPCRM"
        >
        </iframe>
    );
}

export function CHATScreenPopTab() {
    return (
        <iframe src={url}
            sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-modals allow-downloads"
            allow="geolocation; microphone; camera;display-capture"
            style={{ width: '100%', height: '100%', display: 'table-row', border: '0' }}
            name="OzonetelChatPopCRM" id="OzonetelChatPopCRM" title="OzonetelChatPopCRM">
        </iframe>
    )
}

export function PostScreenPop() {

    const callData = useSelector((state) => state.call.callDetails) || {}
    const loginData = useSelector((state) => state.toolbar.loginDetails);

    const AGENT_ID_PH = useSelector((state) => state.toolbar.params.AGENT_ID_PH)
    const AGENT_KEY_PH = useSelector((state) => state.toolbar.params.AGENT_KEY_PH)
    const CUST_PH = useSelector((state) => state.toolbar.params.CUST_PH)
    const AGENT_PHONE_PH = useSelector((state) => state.toolbar.params.AGENT_PHONE_PH)
    const SEND_CUST_PARAMS = useSelector((state) => state.toolbar.params.SEND_CUST_PARAMS)
    const SPOP_CALLERID_ONLY = useSelector((state) => state.toolbar.params.SPOP_CALLERID_ONLY)
    const callType = useMemo(() => callData?.type, [callData?.type]);

    function handleCallScreenPop(data, updateRedux = true) {
        if (callData.screenPop && callData.screenPop !== null && callData.screenPop !== "") {
            let popurl = callData.screenPop + callData.callerId
                + "&ucid=" + callData.ucid
                + "&did=" + callData.did
                + "&callerID=" + callData.callerId
                + "&skillName=" + (callData?.skillName?.includes('#') ? callData?.skillName?.split('#')[0] : callData?.skillName)
                + "&agentUniqueID=" + callData.agentUniqueID
                + "&dataID=" + callData.dataId
                + "&campaignID=" + callData.campaignId
                + "&campaignName=" + callData.campaignName
                + "&monitorUcid=" + callData.monitorUcid
                + "&agentPhoneNumber=" + loginData.phoneNumber
                + "&phoneName=" + callData.phoneName
                + "&type=" + (callData.callType === 'IncomingCall' ? "Inbound" : "Manual")
                + "&apiKey=" + loginData.agentInfo.user.apiKey
                + "&event=" + callData.type
                + "&screenpopupType=ClientSide"

            if (callData.uui && callData.uui.match(/\S/g)) {
                popurl = popurl + "&uui=" + callData.uui;
            }
            if (callData.extraData && callData.extraData.match(/\S/g)) {
                popurl = popurl + callData.extraData;
            }
            if (popurl) {
                if (SEND_CUST_PARAMS === 'true') {
                    if (AGENT_ID_PH) {
                        popurl = popurl + '&' + AGENT_ID_PH + '=' + loginData.agentInfo.agentId
                    }
                    if (AGENT_KEY_PH) {
                        popurl = popurl + '&' + AGENT_KEY_PH + '=' + loginData.agentKey
                    }
                    if (CUST_PH) {
                        popurl = popurl + '&' + CUST_PH + '=' + loginData.customer
                    }
                    if (AGENT_PHONE_PH) {
                        popurl = popurl + '&' + AGENT_PHONE_PH + '=' + loginData.phoneNumber
                    }
                } else {
                    popurl = popurl + "&agentID=" + loginData.agentInfo.agentId + "&customer=" + loginData.customer
                }
            }
            if (SPOP_CALLERID_ONLY === 'true') {
                popurl = callData.screenPop + callData.callerId
            }
            return popurl
        }
    }

    useEffect(() => {
        handlePostScreenPopup();
    }, [callType]);

    function queryStringToJSON(str) {
        let pairs = str.split("&");
        let result = {};
        pairs.forEach(function (pair) {
            pair = pair.split('=');
            let val = pair[1];
            if (val) {
                result[pair[0]] = decodeURIComponent(pair[1] || '');
            }
        });
        return JSON.parse(JSON.stringify(result));
    }

    function handlePostScreenPopup() {
        if (callData && callData?.screenPop === '5' && callData?.screenPopOn === "PLUGIN") {
            url = handleCallScreenPop(callData, false);
            if (url) {
                let result = queryStringToJSON(url);
                result["cmd"] = "screenpop";
                window.parent.postMessage(result, "*");
            }
        }
    }

}

export default ScreenPopTab;